<template>
  <div>
    <v-row>
      <!-- Left side: Membership System Preview -->
      <v-col
        cols="12"
        md="4"
        class=""
      >
        <membership-system-preview
          ref="preview"
          :system-info="systemInfo"
          :text-color="textColor"
        />
      </v-col>

      <!-- Right side: Tabbed Settings -->
      <v-col
        cols="12"
        md="8"
      >
        <v-card elevation="2">
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="primary"
            touchless
            show-arrows
            next-icon="mdi-arrow-right"
            prev-icon="mdi-arrow-left"
            center-active
            fixed-tabs
            active-class="active-tab"
            @change="handleTabChange"
            @click.prevent
          >
            <v-tab
              :value="0"
              @click.native.stop.prevent="handleTabChange(0)"
            >
              会员等级
            </v-tab>
            <v-tab
              :value="1"
              @click.native.stop.prevent="handleTabChange(1)"
            >
              积分规则
            </v-tab>
            <v-tab
              :value="2"
              @click.native.stop.prevent="handleTabChange(2)"
            >
              会员权益
            </v-tab>
          </v-tabs>
          <v-divider />
          <v-card-text class="pa-0">
            <v-tabs-items
              v-model="tab"
              style="background: transparent"
              eager
              @change="handleTabChange"
            >
              <v-tab-item :value="0">
                <membership-level @membership-levels-updated="refreshMembershipLevelsPreview" />
              </v-tab-item>
              <v-tab-item :value="1">
                <point-rule-form
                  :system-info="systemInfo"
                  @update:system-info="updateSystem"
                />
              </v-tab-item>
              <v-tab-item :value="2">
                <membership-benefit />
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MembershipLevel from '@/views/AadenPages/memberShipReborn/LevelsAndPoints/MembershipLevel.vue'
import PointRuleForm from '@/views/AadenPages/memberShipReborn/LevelsAndPoints/PointRuleForm.vue'
import MembershipBenefit from '@/views/AadenPages/memberShipReborn/Benefit/MembershipBenefit.vue'
import MembershipSystemPreview from '@/views/AadenPages/memberShipReborn/Core/MembershipSystemPreview.vue'
import { getMembershipSystem, updateMembershipSystem } from '@/model/dataLayer/api/MembershipSystem/MembershipSystem'
import { showSuccessMessage } from '@/model/utils/utils'

export default {
  name: 'LevelsAndPoints',
  components: {
    MembershipLevel,
    PointRuleForm,
    MembershipBenefit,
    MembershipSystemPreview
  },
  data () {
    return {
      tab: 0,
      loading: false,
      systemInfo: {}
    }
  },
  computed: {
    displayInfo: function () {
      return this.systemInfo.displayInfo
    },
    textColor: function () {
      if (!this.systemInfo.displayInfo || !this.systemInfo.displayInfo.color) {
        return 'black'
      }
      return this.calculateTextColor(this.systemInfo.displayInfo.color)
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    handleTabChange (val) {
      this.tab = val
    },
    async reload () {
      this.loading = true
      this.systemInfo = (await getMembershipSystem())

      // Ensure displayInfo exists
      if (!this.systemInfo.displayInfo) {
        this.systemInfo.displayInfo = {
          name: '',
          description: '',
          imageUrl: '',
          color: '#eeeeee'
        }
      }

      this.loading = false
    },
    async updateSystem (updatedInfo) {
      this.systemInfo = updatedInfo
      await this.saveSystem()
    },
    async saveSystem () {
      await updateMembershipSystem(this.systemInfo)
      showSuccessMessage('成功了！')
    },
    // Method to refresh the membership levels in the preview
    refreshMembershipLevelsPreview () {
      if (this.$refs.preview) {
        this.$refs.preview.loadMembershipLevels()
      }
    },

    // Calculate appropriate text color (black or white) based on background color
    calculateTextColor (bgColor) {
      // Default to black if no color is provided
      if (!bgColor) return 'black'

      // Calculate luminance
      let r, g, b

      // Remove # if present
      bgColor = bgColor.replace('#', '')

      // Handle shorthand hex (#RGB)
      if (bgColor.length === 3) {
        r = parseInt(bgColor[0] + bgColor[0], 16) / 255
        g = parseInt(bgColor[1] + bgColor[1], 16) / 255
        b = parseInt(bgColor[2] + bgColor[2], 16) / 255
      } else {
        r = parseInt(bgColor.substring(0, 2), 16) / 255
        g = parseInt(bgColor.substring(2, 4), 16) / 255
        b = parseInt(bgColor.substring(4, 6), 16) / 255
      }

      // Calculate luminance using WCAG formula
      const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b

      // Use white text for dark backgrounds, black text for light backgrounds
      return luminance > 0.5 ? 'black' : 'white'
    }
  }
}
</script>

<style scoped>
.active-tab {
  font-weight: bold;
  color: #1976d2 !important;
}
</style>
